const groups = [
  { title: "Programming", skills: [["C++", 5], ["Python", 5], ["JavaScript", 4], ["MATLAB", 4], ["Bash", 4]] },
  { title: "Robotics", skills: [["ROS 2", 5], ["ROS 1", 4], ["Gazebo", 5], ["RViz", 4], ["SLAM", 4], ["Foxglove", 4]] },
  { title: "Systems", skills: [["Linux", 5], ["Docker", 4], ["Git", 5], ["Embedded systems", 4], ["Microcontrollers", 4]] },
  { title: "Perception & AI", skills: [["LiDAR", 5], ["OpenCV", 4], ["PCL", 4], ["Computer vision", 4], ["NumPy / Pandas", 4]] },
];

export default function Skills() {
  return (
    <section id="skills" className="skills-section background-alt">
      <div className="container" data-aos="fade-up">
        <div className="section-title section-title-left">
          <span className="section-index">06 — Expertise</span>
          <h2>Tools I use to make robots work</h2>
          <p>Grouped by engineering domain, with proficiency based on hands-on project and research experience.</p>
        </div>
        <div className="expertise-grid">
          {groups.map((group) => (
            <article className="expertise-card" key={group.title}>
              <h3>{group.title}</h3>
              <ul>{group.skills.map(([skill, level]) => (
                <li key={skill}><span>{skill}</span><span className="skill-rating" aria-label={`${level} out of 5 proficiency`}>{"●".repeat(level)}<i>{"●".repeat(5 - level)}</i></span></li>
              ))}</ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
